import { gql } from "@apollo/client";

export const PICKUP_TASK_APPOINTMENT_FIELDS = gql`
  fragment PickupTaskAppointmentFields on PickupTaskAppointmentWithAddressType {
    id
    sequence
    site
    zipcode
    addressLine1
    addressLine2
    country
    state
    city
    quantity
    unit
    appointmentTime
    actualQuantity
    actualUnit
    actualTime
    businessHours
    businessDays
    status
    contactName
    contactPhone
    ext
    channelName
    appointmentNumber
    taskId
    warehouseId
    cooperationWarehouseId
    isFinished
    isAbnormal
    isNewWarehouse
    linkStatus
    photosUrls
    exceptionPhotosUrls
    unloadingTime
    actualPickupTime
    exceptionReasonCode
    unloadingPhotosUrls
    actCompleteTime
    remark
    latitude
    longitude
    hasLinkedPickupOrder
    licensePlate
    hubName
    hubSortingCode
    hubAddress
    hubContactName
    hubContactPhone
    hubTimezoneLocation
    trackingScanEnabled
  }
`;

export interface PickupAppointmentType {
  id: string;
  sequence: number;
  site: string;
  zipcode: string;
  addressLine1: string;
  addressLine2?: string;
  country?: string;
  state?: string;
  city?: string;
  quantity: number;
  unit: string;
  appointmentTime: string;
  actualQuantity: number;
  actualUnit: string;
  actualTime: string;
  businessHours: string;
  businessDays: number[];
  status: string;
  contactName: string;
  contactPhone: string;
  ext: string;
  channelName: string;
  appointmentNumber?: string;
  taskId: string;
  warehouseId: string;
  cooperationWarehouseId?: string;
  isFinished: boolean;
  isAbnormal: boolean;
  isNew?: boolean;
  isNewWarehouse: boolean;
  /** 揽收站点 2.0 建联状态(1待上门/2揽收成功待建联/3揽收失败待建联/4已建联/5确认无法建联/6上门中)；null=非灰度或历史存量 */
  linkStatus?: number | null;
  photosUrls?: string[];
  exceptionPhotosUrls?: string[];
  unloadingPhotosUrls?: string[];
  unloadingTime: string;
  actualPickupTime: string;
  exceptionReasonCode: string;
  remark: string;
  latitude?: number | null;
  longitude?: number | null;
  hasLinkedPickupOrder: boolean;
  /** 车牌号（pickup_task 快照）*/
  licensePlate?: string | null;
  /** 收货方 HUB 快照，随任务下发，弱网/离线下 BOL 也能渲染完整 */
  hubName?: string | null;
  /** HUB 分拨代码（如 LAX），BOL 收货方优先展示 */
  hubSortingCode?: string | null;
  hubAddress?: string | null;
  hubContactName?: string | null;
  hubContactPhone?: string | null;
  /** HUB 的 IANA 时区（如 America/Los_Angeles），BOL 单据日期按此时区计算 */
  hubTimezoneLocation?: string | null;
  /**
   * 本预约单所属 HUB 是否命中「运单号扫描」灰度。
   * 随任务查询一并下发而非单独查开关：两个独立请求会出现"任务加载出来了但开关没加载出来"，
   * 表现为扫描模块该有却不见、或延迟突然冒出来
   */
  trackingScanEnabled?: boolean | null;
}